<div class="title">Profile Details</div>
<form [formGroup]="profileForm">
  <div class="input-container">
    <div>
      @if (p.firstName.valid || p.firstName.untouched) {
        <label for="firstName">First Name</label>
      }
      @if (p.firstName.invalid && p.firstName.touched) {
        <span class="red">
          {{ p.firstName.errors?.required ? 'Please enter your first name' : '' }}
          {{ p.firstName.errors?.email ? 'This looks like an email address, please enter your name' : '' }}
        </span>
      }
    </div>
    <input id="firstName" formControlName="firstName" [class.red]="p.firstName.invalid && p.firstName.touched" />
  </div>
  <div class="input-container">
    <div>
      @if (p.lastName.valid || p.lastName.untouched) {
        <label for="lastName">Last Name</label>
      }
      @if (p.lastName.invalid && p.lastName.touched) {
        <span class="red">
          {{ p.lastName.errors?.required ? 'Please enter your last name' : '' }}
          {{ p.lastName.errors?.email ? 'This looks like an email address, please enter your name' : '' }}
        </span>
      }
    </div>
    <input id="lastName" formControlName="lastName" [class.red]="p.lastName.invalid && p.lastName.touched" />
  </div>

  <div class="input-container">
    <div>
      <label for="email">Email Address</label>
    </div>
    <input type="email" id="email" placeholder="YourName@Company.com" formControlName="email" />
  </div>
  <div class="input-container">
    <div>
      @if ((p.country.valid || p.country.untouched) && p.countryOther.valid) {
        <label for="country">Country</label>
      }
      @if ((p.country.invalid && p.country.touched) || p.countryOther.invalid) {
        <span class="red">
          {{ p.country.errors?.required ? 'Please select your country' : '' }}
          {{ p.countryOther.errors?.required ? 'Please enter your country' : '' }}
        </span>
      }
    </div>
    <div class="input" [class.red]="(p.country.invalid && p.country.touched) || p.countryOther.invalid">
      <mat-select
        id="country"
        formControlName="country"
        panelClass="role-select-panel"
        placeholder="Please select your country"
        [class.red]="(p.country.invalid && p.country.touched) || p.countryOther.invalid"
      >
        @for (country of COUNTRIES; track country) {
          <mat-option [value]="country">{{ country }}</mat-option>
        }
      </mat-select>
      @if (p.country.value === 'Other') {
        <input [@grow]="'inOut'" placeholder="Please specify country" formControlName="countryOther" />
      }
    </div>
  </div>
  <div class="input-container">
    <div>
      @if (p.role.valid || p.role.untouched) {
        <label for="role"> Professional Role </label>
      }
      @if (p.role.invalid && p.role.touched) {
        <span class="red">
          {{ p.role.errors?.required ? 'Please enter in your role' : '' }}
        </span>
      }
    </div>
    <div class="input" [class.red]="p.role.invalid && p.role.touched">
      <mat-select
        id="role"
        formControlName="role"
        panelClass="role-select-panel"
        placeholder="Please select your role in the organization"
        [class.red]="p.role.invalid && p.role.touched"
      >
        @for (role of ROLES; track role) {
          <mat-option [value]="role">{{ role }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div class="input-container">
    <div>
      <label for="organizationalRole">Organizational Role</label>
    </div>
    <input id="organizationalRole" formControlName="organizationalRole" />
  </div>
  @if (showUserRole) {
    <div class="input-container">
      <div>
        <label for="userRole">User Role</label>
      </div>
      <input id="userRole" formControlName="userRole" />
    </div>
  }
</form>
<hr />
<div class="change-password">
  <div class="subheader">Password</div>
  <div>
    <div class="password-hint">
      <a [routerLink]="['/reset']" [queryParams]="{ step: 2 }">Change Password</a>
    </div>
  </div>
</div>

<div class="right-column">
  <button class="cancel-btn" [disabled]="!formChanged" (click)="onCancel()">Cancel</button>
  <button class="save-btn" [disabled]="!formChanged" (click)="onSubmit()">
    @if (!auth0Store.updateUserInProgress()) {
      <span>Save</span>
    }
    @if (auth0Store.updateUserInProgress()) {
      <gnx-dots-loader />
    }
  </button>
</div>
